import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import '../styles.css';
import { GOTO_START_PAGE, GOTO_PAGE, SHOW_LEADERS } from '../../HOME/REDUX/actions';
import BackIcon from '../../HOME/SVG/BackIcon';
import { hideLeaderboards } from '../../HOME/utils';
import { START_PAGE, GAME_PAGE, HIDE, HELP_PAGE } from '../../HOME/const';
import useGoHome from '../../HOME/useGoHome';

const BackButton = () => {
  const dispatch = useDispatch();
  const goHome = useGoHome();
  const { singleApp, page, fromPage, showLeaders } = useSelector(state => state.common);

  if (singleApp && page === START_PAGE) {
    return null;
  }

  return (
    <div
      className="navigation-button"
      onClick={() => {
        switch (page) {
          case START_PAGE:
            goHome();
            return;
          case HELP_PAGE:
            dispatch({ type: GOTO_PAGE, payload: { page: fromPage || START_PAGE } });
            return;
          case GAME_PAGE:
            if (showLeaders === HIDE) {
              dispatch(GOTO_START_PAGE);
            } else {
              hideLeaderboards(op => dispatch({ type: SHOW_LEADERS, op }));
            }
            return;
          default:
            return;
        }
      }}>
      <BackIcon width="36" />
    </div>
  );
};

export default BackButton;
